import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { UserRole } from '../models/user.model';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const allowedRoles = route.data['roles'] as UserRole[];
  const user = inject(AuthService).currentUser();

  if (!user) {
    inject(Router).navigate(['/dashboard']);
    return false;
  }

  if (user.mavaitro === 'Admin') {
    return true;
  }

  if (!allowedRoles.includes(user.mavaitro)) {
    inject(Router).navigate(['/dashboard']);
    return false;
  }

  return true;
};
